export class CumulativeRainfall {
  constructor(readonly cumulAgregationTimeMinutes: number, readonly cumulativeTimeMinutes: number) {}
}
